import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/lib/AuthContext";
import { usePageviewTracker } from "@/lib/analytics";
import Seo from "@/components/Seo";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Offerings from "@/pages/Offerings";
import FundingWorksheet from "@/pages/FundingWorksheet";
import BookCall from "@/pages/BookCall";
import Contact from "@/pages/Contact";
import RealityCheck from "@/pages/RealityCheck";
import AIReadiness from "@/pages/AIReadiness";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import MyAccount from "@/pages/MyAccount";

const Wrapped = (Page) => (
  <Layout>
    <Page />
  </Layout>
);

function PageviewTracker() {
  usePageviewTracker();
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

function AppRouter() {
  const location = useLocation();
  // Intercept OAuth callback fragment before any route runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <PageviewTracker />
      <Seo />
      <Routes>
        <Route path="/" element={Wrapped(Home)} />
        <Route path="/about" element={Wrapped(About)} />
        <Route path="/offerings" element={Wrapped(Offerings)} />
        <Route path="/services" element={<Navigate to="/offerings" replace />} />
        {/* Archived service pages redirect to their Offerings section */}
        <Route path="/ai-education" element={<Navigate to="/offerings#ai" replace />} />
        <Route path="/workflow-app-builds" element={<Navigate to="/offerings#ai" replace />} />
        <Route path="/business-consulting" element={<Navigate to="/offerings#consulting" replace />} />
        <Route path="/funding-readiness" element={<Navigate to="/offerings#consulting" replace />} />
        <Route path="/funding-readiness-worksheet" element={Wrapped(FundingWorksheet)} />
        <Route path="/speaking-workshops" element={<Navigate to="/offerings#speaking" replace />} />
        <Route path="/ai-readiness" element={Wrapped(AIReadiness)} />
        <Route path="/book-call" element={Wrapped(BookCall)} />
        <Route path="/contact" element={Wrapped(Contact)} />
        <Route path="/realitycheck" element={<RealityCheck />} />
        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={Wrapped(Home)} />
      </Routes>
    </>
  );
}

export default App;
